import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { SwitchMenuItem } from '@gem/ui-kit';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

import styles from './SwitchCompactView.styles.m.css';

export const SwitchCompactView: FC = observer(() => {
  const { t } = useTranslation();

  const onChange = (): void => {
    Tasks.calendar.setCompactView(!Entities.calendar.isCompactViewEnabled);
  };

  return (
    <SwitchMenuItem
      title={t('calendar_view_chat_sidebar_header')}
      subTitle={t('calendar_view_chat_sidebar')}
      isChecked={Entities.calendar.isCompactViewEnabled}
      dataTest="calendar-view-compact-switch"
      onChange={onChange}
      className={styles.switch}
    />
  );
});
